import { render, staticRenderFns } from "./IQAnswerSourceLink.vue?vue&type=template&id=ddc1173a&scoped=true"
import script from "./IQAnswerSourceLink.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAnswerSourceLink.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAnswerSourceLink.vue?vue&type=style&index=0&id=ddc1173a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc1173a",
  null
  
)

export default component.exports